import React from 'react'
import { Icon as MuiIcon, useTheme } from '@mui/material'

export const Icon = ({
  fontStyle = 'far',
  icon = '',
  size = 2,
  style = {},
  ...props
}) => {
  const theme = useTheme()
  return (
    <MuiIcon
      style={{ lineHeight: theme.spacing(size + 1), ...style }}
      className={`${fontStyle} ${icon}`}
      size={size}
      {...props}
    />
  )
}

/**
 * @visibleName Icons
 */

export const AddIcon = (props) => <Icon icon="fa-plus" {...props} />
export const AddPhoneIcon = (props) => <Icon icon="fa-phone-plus" {...props} />
export const AngleDownIcon = (props) => <Icon icon="fa-angle-down" {...props} />
export const AngleLeftIcon = (props) => <Icon icon="fa-angle-left" {...props} />
export const AngleRightIcon = (props) => (
  <Icon icon="fa-angle-right" {...props} />
)
export const AnglesRightIcon = (props) => (
  <Icon icon="fa-angles-right" {...props} />
)
export const AnglesLeftIcon = (props) => (
  <Icon icon="fa-angles-left" {...props} />
)
export const AnglesDownIcon = (props) => (
  <Icon icon="fa-angles-down" {...props} />
)
export const AnglesUpIcon = (props) => <Icon icon="fa-angles-up" {...props} />
export const AngleUpIcon = (props) => <Icon icon="fa-angle-up" {...props} />
export const ArrowDownAZIcon = (props) => (
  <Icon icon="fa-arrow-down-a-z" {...props} />
)
export const ArrowLeftIcon = (props) => <Icon icon="fa-arrow-left" {...props} />
export const ArrowRightArrowLeftIcon = (props) => (
  <Icon icon="fa-arrow-right-arrow-left" {...props} />
)
export const ArrowRightFromBracketIcon = (props) => (
  <Icon icon="fa-arrow-right-from-bracket" {...props} />
)
export const ArrowRightIcon = (props) => (
  <Icon icon="fa-arrow-right" {...props} />
)
export const ArrowRotateRight = (props) => (
  <Icon icon="fa-arrow-rotate-right" {...props} />
)
export const ArrowsFromLineIcon = (props) => (
  <Icon icon="fa-arrows-from-line" {...props} />
)
export const ArrowsToLineIcon = (props) => (
  <Icon icon="fa-arrows-to-line" {...props} />
)
export const ArrowUpAZIcon = (props) => (
  <Icon icon="fa-arrow-up-a-z" {...props} />
)
export const ArrowUpRightFromSquareIcon = (props) => (
  <Icon icon="fa-arrow-up-right-from-square" {...props} />
)
export const BedIcon = (props) => <Icon icon="fa-bed" {...props} />
export const BugIcon = (props) => <Icon icon="fa-bug" {...props} />
export const BullseyePointerIcon = (props) => (
  <Icon icon="fa-bullseye-pointer" {...props} />
)
export const CalendarDayIcon = (props) => (
  <Icon icon="fa-calendar-day" {...props} />
)
export const PowerOffIcon = (props) => <Icon icon="fa-power-off" {...props} />
export const CaretDownIcon = (props) => <Icon icon="fa-caret-down" {...props} />
export const CaretRigthIcon = (props) => (
  <Icon icon="fa-caret-right" {...props} />
)
export const ChatIcon = (props) => <Icon icon="fa-comment-dots" {...props} />
export const CheckIcon = (props) => <Icon icon="fa-check" {...props} />
export const CheckSquareIcon = (props) => (
  <Icon icon="fa-check-square" {...props} />
)
export const ChromecastIcon = (props) => (
  <Icon icon="fa-brands fa-chromecast" {...props} />
)
export const CircleCheckIcon = (props) => (
  <Icon icon="fa-circle-check" {...props} />
)
export const CircleExclamationIcon = (props) => (
  <Icon icon="fa-circle-exclamation" {...props} />
)
export const CircleIcon = (props) => <Icon icon="fa-circle" {...props} />
export const CircleInfoIcon = (props) => (
  <Icon icon="fa-circle-info" {...props} />
)
export const CircleQuestionIcon = (props) => (
  <Icon icon="fa-circle-question" {...props} />
)
export const CircleXMarkIcon = (props) => (
  <Icon icon="fa-circle-xmark" {...props} />
)
export const CloseIcon = (props) => <Icon icon="fa-times" {...props} />
export const CompassIcon = (props) => <Icon icon="fa-compass" {...props} />
export const CrownIcon = (props) => <Icon icon="fa-crown" {...props} />
export const CsvIcon = (props) => <Icon icon="fa-file-csv" {...props} />
export const DashboardIcon = (props) => (
  <Icon icon="fa-objects-column" {...props} />
)
export const DeleteIcon = (props) => <Icon icon="fa-trash" {...props} />
export const DownIcon = (props) => <Icon icon="fa-chevron-down" {...props} />
export const DownloadIcon = (props) => (
  <Icon icon="fa-arrow-to-bottom" {...props} />
)
export const DownToLineIcon = (props) => (
  <Icon icon="fa-thin fa-down-to-line" {...props} />
)
export const DropletIcon = (props) => <Icon icon="fa-droplet" {...props} />
export const EditIcon = (props) => <Icon icon="fa-edit" {...props} />
export const EllipsisIcon = (props) => <Icon icon="fa-ellipsis-h" {...props} />
export const EmptyIcon = (props) => <Icon icon="fa-empty-set" {...props} />
export const EthernetIcon = (props) => <Icon icon="fa-ethernet" {...props} />
export const ExclamationIcon = (props) => (
  <Icon icon="fa-exclamation" {...props} />
)
export const ExclamationTriangleIcon = (props) => (
  <Icon icon="fa-exclamation-triangle" {...props} />
)
export const ExportIcon = (props) => <Icon icon="fa-file-export" {...props} />
export const EyeIcon = (props) => <Icon icon="fa-eye" {...props} />
export const EyeSlashIcon = (props) => <Icon icon="fa-eye-slash" {...props} />
export const FilterIcon = (props) => <Icon icon="fa-filter" {...props} />
export const FloppyDiskIcon = (props) => (
  <Icon icon="fa-floppy-disk" {...props} />
)
export const GaugeIcon = (props) => <Icon icon="fa-gauge" {...props} />
export const GearIcon = (props) => <Icon icon="fa-gear" {...props} />
export const GlobeEuropeIcon = (props) => (
  <Icon icon="fa-globe-europe" {...props} />
)
export const KeyIcon = (props) => <Icon icon="fa-key" {...props} />
export const LaptopMobileIcon = (props) => (
  <Icon icon="fa-laptop-mobile" {...props} />
)
export const ListIcon = (props) => <Icon icon="fa-list" {...props} />
export const LocationCrosshairsIcon = (props) => (
  <Icon icon="fa-location-crosshairs" {...props} />
)
export const LocationDotIcon = (props) => (
  <Icon icon="fa-location-dot" {...props} />
)
export const MasksTheaterIcon = (props) => (
  <Icon icon="fa-masks-theater" {...props} />
)
export const MicroChipIcon = (props) => <Icon icon="fa-microchip" {...props} />
export const MinusIcon = (props) => <Icon icon="fa-minus" {...props} />
export const MinusSquareIcon = (props) => (
  <Icon icon="fa-minus-square" {...props} />
)
export const NextIcon = (props) => <Icon icon="fa-chevron-right" {...props} />
export const NotebookIcon = (props) => <Icon icon="fa-book" {...props} />
export const ObjectsColumnIcon = (props) => (
  <Icon icon="fa-objects-column" {...props} />
)
export const OrganismIcon = (props) => (
  <Icon icon="fa-globe-africa" {...props} />
)
export const PauseIcon = (props) => <Icon icon="fa-pause" {...props} />
export const PdfIcon = (props) => <Icon icon="fa-file-pdf" {...props} />
export const PencilIcon = (props) => <Icon icon="fa-pencil" {...props} />
export const PeriodIcon = (props) => <Icon icon="fa-period" {...props} />
export const PlugIcon = (props) => <Icon icon="fa-plug" {...props} />
export const PlusCircleIcon = (props) => (
  <Icon icon="fa-plus-circle" {...props} />
)
export const PreviousIcon = (props) => (
  <Icon icon="fa-chevron-left" {...props} />
)
export const PrintIcon = (props) => <Icon icon="fa-print" {...props} />
export const ProcessIcon = (props) => <Icon icon="fa-sync fa-spin" {...props} />
export const RectangleBarcodeIcon = (props) => (
  <Icon icon="fa-rectangle-barcode" {...props} />
)
export const ResetIcon = (props) => <Icon icon="fa-sync" {...props} />
export const SearchIcon = (props) => <Icon icon="fa-search" {...props} />
export const SignalStreamIcon = (props) => (
  <Icon icon="fa-signal-stream" {...props} />
)
export const SiteIcon = (props) => <Icon icon="fa-map-marker-alt" {...props} />
export const SitemapIcon = (props) => <Icon icon="fa-sitemap" {...props} />
export const SortDownIcon = (props) => <Icon icon="fa-arrow-down" {...props} />
export const SortIcon = (props) => (
  <Icon icon="fa-arrow-down-arrow-up" {...props} />
)
export const SortUpIcon = (props) => <Icon icon="fa-arrow-up" {...props} />
export const SpinnerIcon = (props) => <Icon icon="fa-spinner" {...props} />
export const SquareIcon = (props) => <Icon icon="fa-square" {...props} />
export const SquarePoolVerticalIcon = (props) => (
  <Icon icon="fa-square-pool-vertical" {...props} />
)
export const TableIcon = (props) => <Icon icon="fa-table" {...props} />
export const TableLayoutIcon = (props) => (
  <Icon icon="fa-table-layout" {...props} />
)
export const TableListIcon = (props) => <Icon icon="fa-table-list" {...props} />
export const ToolboxIcon = (props) => <Icon icon="fa-toolbox" {...props} />
export const TrashIcon = (props) => <Icon icon="fa-trash" {...props} />
export const TVIcon = (props) => <Icon icon="fa-tv" {...props} />
export const UpIcon = (props) => <Icon icon="fa-chevron-up" {...props} />
export const WarningIcon = (props) => <Icon icon="fa-warning" {...props} />
export const WifiIcon = (props) => <Icon icon="fa-wifi" {...props} />
export const WifiSlashIcon = (props) => <Icon icon="fa-wifi-slash" {...props} />
export const XMarkIcon = (props) => <Icon icon="fa-xmark" {...props} />
export const DoubleSliderIcon = (props) => (
  <Icon icon="fa-sliders-simple" {...props} />
)
